import { sendPost } from '../../http.js'
const commons = (url, params, fn) => {
  return sendPost(url, params)
    .then((res) => {
      fn(res)
      //console.log('成功')
    }).catch((err) => {
		throw Error(err)
      fn(err)
      //console.log('失败')
  })
}
const api = {
	'createClassApi': '/user/user/productlist',
	'cateListApi': '/user/user/catelistnew',
	'singleproduct':'/user/user/singleproduct',
	'singleindex': '/user/user/singleindex',
	'productrecall': '/user/user/productrecall',
	'getpdf': '/user/user/getpdf',
	'uprightsdesc': '/user/user/uprightsdesc',
	'userGetCode': '/user/user/getcode'
}

export default {
	 createClassApi(params, fn) {
	 	commons(api.createClassApi, params, fn)
	 },
	cateListApi(params, fn) {
		commons(api.cateListApi, params, fn)
	},
	singleproduct(params) {
		return sendPost(api.singleproduct, params)
	},
	singleindex(params, fn) {
		commons(api.singleindex, params, fn)
	},
	productrecall(params) {
		return sendPost(api.productrecall, params)
	},
	getpdf(params) {
		return sendPost(api.getpdf, params)
	},
	uprightsdesc(params) {
		return sendPost(api.uprightsdesc, params)
	},
	userGetCode(params) {
		return sendPost(api.userGetCode, params)
	}
	
}
